import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Home from "../components/home/home";
import createErrorBoundary from "shared/components/wrappers/errorBoundary";
import "../lib/callsWebsocket";

const mapStateToProps = (state, ownProps) => {
  return {
    currentContractor: state.home.currentContractor,
    defaultCompanyId: state.home.defaultCompanyId,
    topTranscribers: state.home.topTranscribers,
    weekStart: state.home.weekStart,
    weekEnd: state.home.weekEnd,
    teamLead: state.home.teamLead,
    bonus: state.home.bonus,
    transcriptionSecondPassQueue: state.home.transcriptionSecondPassQueue,
    transcriptionQaQueue: state.home.transcriptionQaQueue,
    transcriptionQueue: state.home.transcriptionQueue,
    companyResponses: state.home.companyResponses,
    companyFeedback: state.home.companyFeedback,
    siteSummary: state.home.siteSummary,
    callbackSchedulingQaNum: state.home.callbackSchedulingQaNum,
    pendingTranscripts: state.home.pendingTranscripts,
    availableTranscripts: state.home.availableTranscripts,
    queueAuthToken: state.home.queueAuthToken,
    instacallUrl: state.home.instacallUrl,
  };
};

// Access relevant actions here
const mapDispatchToProps = (dispatch) => ({});

export default createErrorBoundary()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))
);
